import TextCard from './TextCard'

export default TextCard
